import { CountLinkButton } from 'Components/Buttons/CountLinkButton';
import { useCachedData } from 'Components/Context/CachedDataContext';
import { ColumnConfig, ColumnType } from 'Components/Table/Columns';
import { Table } from 'Components/Table/Table';
import { iso8601ToUsDateShort } from 'Helpers/DateTimeUtils/DateTimeUtils';
import { ActionHistory } from 'Models/Actions';

export interface ActionHistoryTableProps {
    histories: ActionHistory[];
    onSelectHistory: (history: ActionHistory) => void;
    showRisks: (history: ActionHistory) => void;
}

export const ActionHistoryTable = (props: ActionHistoryTableProps) => {
    const cachedData = useCachedData();

    const columns: ColumnConfig<ActionHistory>[] = [
        {
            type: ColumnType.STRING,
            name: 'Date',
            getString: (history) => iso8601ToUsDateShort(history.last_updated),
            getOnClickTextAction: (history) => ({ execute: () => props.onSelectHistory(history) }),
        },
        {
            type: ColumnType.STRING,
            name: 'Status',
            getString: (history) => history.status,
        },
        {
            type: ColumnType.USER,
            name: 'Owner',
            getUserId: (history) => history.owner,
            users: cachedData.users,
        },
        {
            type: ColumnType.CUSTOM,
            name: 'Risks',
            getTableCellContent: (history) => <CountLinkButton count={history.associated_risks.length} noun="Risk" onClick={() => props.showRisks(history)} />,
            getValue: (history) => history.associated_risks.length,
            sortComparator: (a, b) => a - b,
        },
        {
            type: ColumnType.DATE,
            name: 'Due Date',
            getDateString: (history) => history.due_date,
        },
    ];

    return <Table<ActionHistory> columns={columns} defaultSortColumn="Date" defaultSortDirection="descending" filters={[]} getUniqueIdForRow={(history) => history.last_updated} rowsData={props.histories} disableSorting />;
};
